import { DataAlertsFilterTable } from "./DataAlertsFilterTable";

const DataAlertsFilters = ({
  selectables,
  onTagFilterSelected,
  onAllTagsSelected,
}) => {
  const columns = [
    {
      accessorKey: "label",
      header: "",
    },
    {
      accessorKey: "occurrences",
      header: "",
    },
  ];

  return (
    <div className="w-1/5">
      <DataAlertsFilterTable
        columns={columns}
        data={selectables}
        onTagFilterSelected={onTagFilterSelected}
        onAllTagsSelected={onAllTagsSelected}
      />
    </div>
  );
};

export default DataAlertsFilters;
